import { ReactNode } from 'react';
import cn from 'classnames';
import styles from './DashboardCard.module.css';

type Props = {
    children?: ReactNode;
    className?: string;
};

const DashboardCard = ({ children, className }: Props) => {
    return <div className={cn(styles.container, className)}>{children}</div>;
};

const Title = ({ children, className }: Props) => {
    return <h2 className={cn(styles.title, className)}>{children}</h2>;
};

DashboardCard.Title = Title;

export default DashboardCard;
